/**
 * Breakpoint helpers used by the dashboard editor shell.
 */
export default class DashboardBreakpointHelper {
    /**
     * Resolve the visible width from one breakpoint media query.
     */
    static getBreakpointWidth(breakpoint) {
        const mediaQuery = breakpoint.mediaQuery.mediaQuerySubList.find((item) => item.mediaTypes.includes('screen'));
        const feature = mediaQuery.features.find((item) => item.name === 'max-width');

        return feature.value;
    }
}
